import React from 'react'
import { motion } from 'framer-motion';
import { GoPackageDependents } from "react-icons/go";
import { GiPoliceOfficerHead } from "react-icons/gi";
import Navbar from '../../components/common/Navabar'
import serviceImage from "../../asserst/websiteImage/serviceImage.png"
import car from "../../asserst/websiteImage/car.png";
import bus from "../../asserst/websiteImage/bus.png";
import traveller from "../../asserst/websiteImage/traveller.png";
import urbiana from "../../asserst/websiteImage/urbaina.png";
import FAQ from "../../asserst/websiteImage/FAQ.png"
import Footer from '../../components/common/Footer';
import discover from "../../asserst/websiteImage/discover.png"
import delivery from "../../asserst/websiteImage/dilivery.png"
import destination from "../../asserst/websiteImage/destination.png"
import rental from "../../asserst/websiteImage/rental.png"
import serviceRequest from "../../asserst/websiteImage/serviceRequest.png"

const ServicePage = () => {
  const services = [
    {
      id: 1,
      label: "Car",
      image: car,
    },
    {
      id: 2,
      label: "Bus",
      image: bus,
    },
    {
      id: 3,
      label: "Traveller",
      image: traveller,
    },
    {
      id: 4,
      label: "Urbaina",
      image: urbiana,
    },
  ];

  const servicesBox = [
    {
      id: 1,
      title: "Discover and Select Your Ideal Vehicle",
      description:
        "Explore a variety of vehicles tailored to your specific travel needs, from solo journeys to group transportation.",
      image: discover,
    },
    {
      id: 2,
      title: "Customize Your Rental Plan and Secure Your Booking",
      description:
        "Choose from hourly, daily, weekly, or monthly rental plans, with options for self-drive or chauffeur service.",
      image: delivery,
    },
    {
      id: 3,
      title: "Convenient Pickup or Delivery Service",
      description:
        "Collect your vehicle at our designated locations, or opt for home delivery where available for added ease.",
      image: destination,
    },
    {
      id: 4,
      title: "Enjoy Your Journey and Return with Ease",
      description:
        "Travel confidently with round-the-clock support for any inquiries or assistance.",
      image: rental,
    },
  ];

  return (
    <div className="bg-white">
      <Navbar />
      <motion.section
        className="relative h-[30vh] rounded-b-[30px] "
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >

        <img src={serviceImage} className="h-full w-full object-cover rounded-b-[30px]" alt="Main Bus" />
        <div className="absolute inset-0 bg-[#0739564D] flex rounded-b-[30px] items-center justify-center">
        </div>
        <div className="absolute -bottom-24  flex-col md:w-[25rem] xsm:w-[15rem] md:h-[12rem] xsm:h-[8rem] rounded-xl shadow-lg border-blue-600 border-[2px] left-1/2 transform -translate-x-1/2  bg-white flex text-center items-center justify-center"
          style={{ boxShadow: "10px 10px 30px 0px #0000001A" }}
        >
          <div className='w-full '>
            <motion.h2
              className="font-bold text-gray-800 mb-5 md:text-[50.8px] xsm:text-[2.5rem] w-[100%] leading-[47px]  underline-offset-[from-font] decoration-none"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              Services
            </motion.h2>
            <motion.p
              className="text-gray-500 font-poppins text-base w-[100%] font-normal leading-6  underline-offset-[from-font] decoration-none"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              Home/Service
            </motion.p>
          </div>
        </div>
      </motion.section>
      <section className="w-[100%] md:h-[500px] xsm:h-auto xsm:mt-28 md:mt-5 flex justify-center items-center font-poppins">
        <div className="md:w-[70%] xsm:w-[90%] mx-auto xsm:p-0 md:p-1">
          <p className="text-orange-400 underline underline-offset-1 font-semibold">Services</p>
          <motion.h2
            className="font-bold text-gray-800 mb-5 text-[1.8rem] xsm:w-full md:w-[40%] leading-[40px] underline-offset-[from-font] decoration-none"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            We are always committed to drive your vehicle
          </motion.h2>
          <div className="grid  md:grid-cols-4 xsm:grid-cols-1 sm:grid-cols-2 gap-4">
            {services.map((service) => (
              <div
                key={service.id}
                style={{ boxShadow: "0px 4px 4px 0px #00000017" }}
                className="bg-[#fff] border-[1px] border-[#D9D9D9] col-span-1 flex flex-col rounded-[20px] md:w-[12rem] xsm:h-[12rem] md:h-[8rem] space-y-4 p-4"
              >
                <div className="w-full flex items-end justify-end">
                  <img
                    src={service.image}
                    alt={service.label}
                    className="xsm:h-[110px] md:h-[70px] md:w-[120px] xsm:w-[150px]  mx-auto"
                  />
                </div>
                <p className="font-semibold text-center font-poppins text-gray-800">{service.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="w-[100%] xsm:h-auto md:h-[600px] bg-orange-50 py-20">
        <div className="w-[80%] mx-auto text-center">
          <p className="text-orange-400 underline underline-offset-1 font-semibold">
            Services
          </p>
          <motion.h2
            className="font-bold text-gray-800 md:mb-5 xsm:text-[1.3rem] md:text-[1.8rem] w-[100%] xsm:my-5 md:leading-[40px] text-center underline-offset-[from-font] decoration-none"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            From Booking to Drop-Off,
            <br />
            We’ve Got You Covered
          </motion.h2>

          <div className="grid xsm:grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2 xsm:space-y-2">
            {servicesBox?.map((service) => (
              <div
                key={service.id}
                className="bg-[#fff] space-y-4 col-span-1 w-[18rem] h-[19rem] p-4 rounded-md shadow-md"
              >
                <div className="w-full flex items-end justify-center">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="h-[50px] w-[50px]"
                  />
                </div>
                <p className="font-semibold text-center font-poppins text-gray-800">
                  {service.title}
                </p>
                <motion.p
                  className="text-gray-500 font-poppins text-base w-[100%] font-normal leading-6 underline-offset-[from-font] decoration-none"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                >
                  {service.description}
                </motion.p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className='w-[100%] xsm:h-auto md:h-[500px] flex justify-center items-center font-poppins '>
        <div className=' xsm:w-[90%] md:w-[80%] mx-auto flex md:flex-row xsm:flex-col xsm:justify-center md:justify-between '>
          <div className='xsm:w-[90%] md:w-[45%]'>
            <h2 className="text-[#000] font-bold xsm:text-[1.8rem] md:text-[2.5rem] mb-3 w-[100%] ">
              Which Information  <br />do you wan't  to know?</h2>
            <div className='flex flex-col space-y-2'>
              <div className='w-full flex'>
                <div className='w-[20%] text-[25px] font-bold'>01</div>
                <div className='w-[80%]'>
                  <motion.h2
                    className="font-bold text-gray-800 mb-5 text-[1rem] w-[100%] leaing-[47px]   decoration-none"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    Alright, but why exactly do you do?
                  </motion.h2>

                  <p>Explore a variety of vehicles tailored to your specific travel needs, from solo journeys to group transportation
                  </p>
                </div>
              </div>
              <div className='w-full flex'>
                <div className='w-[20%] text-[25px] font-bold'>02</div>
                <div className='w-[80%]'>
                  <motion.h2
                    className="font-bold text-gray-800 mb-5 text-[1rem] w-[100%] leaing-[47px]   decoration-none"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    Explore a variety of vehicles tailored to your specific travel needs
                  </motion.h2>

                </div>

              </div>
              <div className='w-full flex'>
                <div className='w-[20%] font-bold text-[25px]'>03</div>
                <div className='w-[80%]'>
                  <motion.h2
                    className="font-bold text-gray-800 mb-5 text-[1rem] w-[100%] leaing-[47px]   decoration-none"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    of vehicles tailored to your specific travel needs
                  </motion.h2>
                </div>
              </div>
            </div>
          </div>
          <motion.div
            className='xsm:w-[90%] md:w-[45%] flex place-content-center'
            initial={{ opacity: 0, scale: 0.9 }}  // Initial state with scale effect
            whileInView={{ opacity: 1, scale: 1 }}  // Final state (fade in and scale)
            transition={{ duration: 1, delay: 1 }}  // Delay for image animation
          >
            <img src={FAQ} alt="FAQ" className="" />
          </motion.div>
        </div>
      </section>
      <motion.section
        className="relative h-[15vh] md:h-[30vh] lg:h-[20vh]"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <img src={serviceRequest} className="h-full w-full object-cover" alt="Main Bus" />
        <div className="absolute inset-0 bg-[#02050e80] flex  items-center justify-center text-center space-y-2 p-4">
          <div className='w-[100%] mx-auto flex place-content-center'>
            <div className='w-[60%]'>
              <h2 className="text-white font-bold xsm:text-[1.2rem] md:text-3xl lg:text-4xl">
                Are you looking for a Transport Service?
              </h2>
              <p className="text-white xsm:text-[0.7rem] md:text-base lg:text-lg">
                We always help you to transport your products and documents
              </p>
            </div>
            <button className="mt-4 xsm:py-1 xsm:px-3 md:px-6 py-2 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition">
              Send Request
            </button>
          </div>
        </div>
      </motion.section>
      <div className='bg-[#0B0757] pb-10'>
        <Footer />
      </div>
    </div >
  )
}

export default ServicePage
